import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import './KamuLewu.css';

const documents = [
  { name: 'F-14战机', pdf: '/kamulewu/F-14战机.pdf', thumb: '/kamulewu/F-14战机.png' },
  { name: 'NBA JAM', pdf: '/kamulewu/NBA JAM.pdf', thumb: '/kamulewu/NBA JAM.png' },
  { name: '作弊码合集', pdf: '/kamulewu/作弊码合集.pdf', thumb: '/kamulewu/作弊码合集.png' },
  { name: '侏罗纪公园', pdf: '/kamulewu/侏罗纪公园.pdf', thumb: '/kamulewu/侏罗纪公园.png' },
  { name: '凯撒娱乐场', pdf: '/kamulewu/凯撒娱乐场.pdf', thumb: '/kamulewu/凯撒娱乐场.png' },
  { name: '弟切草', pdf: '/kamulewu/弟切草.pdf', thumb: '/kamulewu/弟切草.png' },
  {
    name: '梦幻模拟战',
    pdf: '/kamulewu/梦幻模拟战.pdf',
    thumb: '/kamulewu/梦幻模拟战.png',
    relatedGamePath: '/game/978',
  },
  { name: '汤尼兔宝宝之顶峰全明星', pdf: '/kamulewu/汤尼兔宝宝之顶峰全明星.pdf', thumb: '/kamulewu/汤尼兔宝宝之顶峰全明星.png' },
  { name: '米格29', pdf: '/kamulewu/米格29.pdf', thumb: '/kamulewu/米格29.png' },
  { name: '蒙面英雄', pdf: '/kamulewu/蒙面英雄.pdf', thumb: '/kamulewu/蒙面英雄.png' },
  { name: '金属海战', pdf: '/kamulewu/金属海战.pdf', thumb: '/kamulewu/金属海战.png' },
];

const KamuLewu = () => {
  const [lightbox, setLightbox] = useState(null); // index of open pdf

  const openLightbox = (index) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const activeDocument = lightbox === null ? null : documents[lightbox];

  useEffect(() => {
    if (!activeDocument) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setLightbox(null);
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeDocument]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) closeLightbox();
  };

  return (
    <div className="kamu-container">
      <Navbar />

      <div className="kamu-content">
        {/* Hero header */}
        <div className="kamu-header">
          <h1 className="kamu-title">卡姆乐屋档案</h1>
          <p className="kamu-description">
            卡姆乐屋档案记录了北京游戏店"卡姆乐屋"中保存的一批手写游戏攻略、翻译与研究笔记。它们大多出自学生玩家之手，见证了在中文资料匮乏的年代，玩家如何靠自发翻译与集体摸索，让更多外文游戏被理解、被玩到，是中国早期玩家社群的鲜活写照。
          </p>
        </div>

        {/* Document grid */}
        <div className="kamu-grid">
          {documents.map((doc, i) => (
            <button
              key={doc.name}
              className="kamu-card"
              onClick={() => openLightbox(i)}
              aria-label={`打开 ${doc.name}`}
            >
              <div className="kamu-card-thumb">
                <img src={doc.thumb} alt={doc.name} loading="lazy" />
                <div className="kamu-card-overlay">
                  <span className="kamu-card-view-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
                      <path d="M1.5 12s3.75-7.5 10.5-7.5S22.5 12 22.5 12 18.75 19.5 12 19.5 1.5 12 1.5 12z" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="kamu-card-label">{doc.name}</div>
            </button>
          ))}
        </div>
      </div>

      {/* PDF Lightbox */}
      {activeDocument && (
        <div
          className="kamu-lightbox"
          onClick={handleBackdropClick}
          role="dialog"
          aria-modal="true"
          aria-label={`${activeDocument.name} 攻略`}
        >
          <div className="kamu-lightbox-inner">
            <div className="kamu-lightbox-topbar">
              <span className="kamu-lightbox-name">{activeDocument.name}</span>
              <div className="kamu-lightbox-actions">
                {activeDocument.relatedGamePath && (
                  <a
                    href={activeDocument.relatedGamePath}
                    className="kamu-related-game-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18" aria-hidden="true">
                      <path d="M8 7h8a5 5 0 0 1 4.8 6.4l-1.1 3.8a2.2 2.2 0 0 1-3.8.8l-1.7-2H9.8l-1.7 2a2.2 2.2 0 0 1-3.8-.8l-1.1-3.8A5 5 0 0 1 8 7z" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 10v4M6 12h4M16.5 11.5h.01M18.5 13.5h.01" strokeLinecap="round"/>
                    </svg>
                    游玩关联游戏
                  </a>
                )}
                <a
                  href={activeDocument.pdf}
                  download
                  className="kamu-lightbox-download"
                  onClick={(e) => e.stopPropagation()}
                  aria-label="下载PDF"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
                    <path d="M12 3v13M7 11l5 5 5-5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M3 18h18" strokeLinecap="round"/>
                  </svg>
                  下载
                </a>
                <button className="kamu-lightbox-close" onClick={closeLightbox} aria-label="关闭">
                  ×
                </button>
              </div>
            </div>
            <iframe
              src={`/flipbook.html?pdf=${encodeURIComponent(activeDocument.pdf)}`}
              title={activeDocument.name}
              className="kamu-lightbox-frame"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default KamuLewu;
